import React, { useEffect } from 'react';
import PrivacyContent from '../components/legal/PrivacyContent';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
        <PrivacyContent />
      </div>
    </div>
  );
}
